export const PATTERNS_ANNOTATION_MODE_STEPS = 0;
export const PATTERNS_ANNOTATION_MODE_PHASES = 1;
export const PATTERNS_ANNOTATION_MODE_COMMENTS_ONLY = 2;

export const isPatternAnnotationMode = (mode) => {
  return parseInt(process.env.REACT_APP_PATTERNS_ANNOTATION_MODE) === mode;
};